import { atom } from "recoil";

export const PlaceDetailState = atom({
  key: "PlaceDetailState",
  default: {
    id: null,
    tag: null,
    key: null,
  },
});
